module.exports = __webpack_public_path__ + "media/images/success-stories-4-cfcf4c9ba3d05f7a5717201ca46b481e.jpeg";